import { ChartData, ChartOptions } from 'chart.js'
import React from 'react'
import { PieChart } from '../pie-chart'
import { AreaChart } from '../area-chart'
import { Bar } from 'react-chartjs-2'

interface DoughnutChartBlockProps {
    type: 'doughnut'
    data: ChartData<'doughnut'>
    options?: ChartOptions<'doughnut'> & { maxLabels?: number }
    children?: React.ReactNode
    title?: string
    chartClass?: string
    noData?: boolean
    noDataComponent?: React.ReactNode
}

interface LineChartBlockProps {
    type: 'line'
    data: ChartData<'line'>
    options?: ChartOptions<'line'>
    children?: React.ReactNode
    title?: string
    chartClass?: string
    noData?: boolean
    noDataComponent?: React.ReactNode
}

interface BarChartBlockProps {
    type: 'bar'
    data: ChartData<'bar'>
    options?: ChartOptions<'bar'>
    children?: React.ReactNode
    title?: string
    chartClass?: string
    noData?: boolean
    noDataComponent?: React.ReactNode
}

type ChartBlockProps = LineChartBlockProps | DoughnutChartBlockProps | BarChartBlockProps

export const ChartBlock: React.FC<ChartBlockProps> = ({ noData, noDataComponent, data, type, chartClass, options, title, children }) => {
    return (
        <div className='box'>
            {children
                ? children
                : <div className='box_header'>
                    {title}
                </div>
            }
            <div className='bg-[#E7EAEE] mb-6 screen:mb-[32px] w-full h-[1px] block'/>
            <div id='chart' className={chartClass}>
                {noData
                    ? noDataComponent
                    : <>
                        {(type === 'doughnut') &&
                            <PieChart data={data} options={{...options, maxLabels: 10}} />
                        }
                        {(type === 'line') &&
                            <AreaChart data={data} options={options} />
                        }
                        {(type === 'bar') &&
                            <Bar data={data} options={options} />
                        }
                    </>
                }
            </div>
        </div>
    )
}
